import React from 'react';
import ConsultingClubPage from './components/ConsultingClubPage';

function App() {
  return (
    <div className="App">
      <ConsultingClubPage />
    </div>
  );
}

export default App; 